import {} from '@mui/material'

// material-ui

// project imports
import ViewContentCreatorInvitationList from 'features/view/content/creator/invitation/list/view-content-creator-invitation-list'

// ==============================|| PROFILE 3 ||============================== //

// styles
const Profile3 = () => {
  return (
    <>
      <ViewContentCreatorInvitationList />
    </>
  )
}

export default Profile3
